// App.js
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Dashboard from "./components/Dashboard";
import SignIn from "./components/auth/signIn";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { jwtDecode } from "jwt-decode";
import AppsPRC from "./prc/App.tsx";
import { validateToken } from "./utils/auth.js";
import { useInactivityTimeout } from "./utils/useInactivityTimeout.js";
import ForgotPassword from "./components/auth/ForgotPassword.jsx";
import ResetPassword from "./components/auth/ResetPassword.jsx";
import AppsPRCViewOnly from "./prc_view_only/App.tsx";

// THEME
const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

// ROOT REDIRECT COMPONENT
function RootRedirect({ token }) {
  try {
    if (!token) return <Navigate to="/signin" replace />;
    const decoded = jwtDecode(token);
    const appUrl = decoded?.appUrl;

    if (!appUrl) return <Navigate to="/signin" replace />;

    const pathname = new URL(appUrl).pathname;
    console.log("pathname" + pathname);

    return <Navigate to={pathname} replace />;
  } catch {
    return <Navigate to="/signin" replace />;
  }
}

// ✅ NEW: Wrapper component inside Router that handles inactivity
function AppRoutes({ token, setToken }) {
  // Call the hook here - inside Router context
  // if (validateToken(token)) {
  //   useInactivityTimeout(setToken);
  // }

  return (
    <Routes>
      {/* LOGIN */}
      <Route
        path="/signin"
        element={
          validateToken(token) ? (
            <RootRedirect token={token} />
          ) : (
            <SignIn setToken={setToken} />
          )
        }
      />

        {/* FORGOT PASSWORD - Public Route */}
      <Route
        path="/forgot-password"
        element={
          validateToken(token) ? (
            <RootRedirect token={token} />
          ) : (
            <ForgotPassword />
          )
        }
      />

      {/* <Route
        path="/reset-password"
        element={
          validateToken(token) ? (
            <RootRedirect token={token} />
          ) : (
            <ResetPassword />
          )
        }
      /> */}

      {/* RESET PASSWORD - Public Route */}
      <Route
        path="/reset-password/:token"
        element={
          validateToken(token) ? (
            <RootRedirect token={token} />
          ) : (
            <ResetPassword />
          )
        }
      />

      {/* ROOT → redirect based on JWT */}
      <Route
        path="/"
        element={
          token ? (
            <RootRedirect token={token} />
          ) : (
            <Navigate to="/signin" replace />
          )
        }
      />

      {/* ADMIN ROUTES */}
      <Route
        path="ZWAD/*"
        element={
          <ProtectedRoute token={token} allowedPath="/ZWAD">
            <Dashboard setToken={setToken} />
          </ProtectedRoute>
        }
      />

      {/* USER ROUTES */}
      <Route
        path="ZXUR/*"
        element={
          <ProtectedRoute token={token} allowedPath="/ZXUR">
            <AppsPRC setToken={setToken} />
          </ProtectedRoute>
        }
      />
      
      {/* VIEW ONLY ROUTES */}
      <Route
        path="ZXVO/*"
        element={
          <ProtectedRoute token={token} allowedPath="/ZXVO">
            <AppsPRCViewOnly setToken={setToken} />
          </ProtectedRoute>
        }
      />

      {/* ANY UNKNOWN PATH → redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {

//   useEffect(() => {
//   // Prevent dragging on iOS
//   const preventDrag = (e) => {
//     if (e.target.tagName !== "INPUT" && e.target.tagName !== "TEXTAREA") {
//       e.preventDefault();
//     }
//   };

//   document.addEventListener("touchmove", preventDrag, { passive: false });

//   return () => {
//     document.removeEventListener("touchmove", preventDrag);
//   };
// }, []);

  const [token, setToken] = useState(() => localStorage.getItem("token"));

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      <Router>
        {/* ✅ Now the hook is called inside Router */}
        <AppRoutes token={token} setToken={setToken} />

        <ToastContainer
          position="bottom-right"
          autoClose={2000}
          theme="dark"
          style={{ zIndex: 9999 }}
        />
      </Router>
    </ThemeProvider>
  );
}

export default App;
